var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardLayout',[_c('TransactionsBody',{attrs:{"transactions":_vm.transaction.transactions,"page":_vm.transaction.page,"total":_vm.transaction.total,"loading":_vm.transaction.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }